import React from 'react';

function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-img" />
      <div className="skeleton-text" />
      <div className="skeleton-text short" />
    </div>
  );
}

export default SkeletonCard;
